// extracted by mini-css-extract-plugin
export default {"auth__wrapper":"styles_auth__wrapper__NLvDa","auth__error":"styles_auth__error__KqwHQ"};